<template>
  <div id="nav">
    <vs-popup :title="title" :active.sync="showDialog">
      <vs-row id="dialog-lost-edit">
        <vs-col class="waste-oil-area" vs-lg="6" vs-sm="6" vs-xs="12">
          <vs-col class="aisea-text-14-400-black">廃油</vs-col>
          <vs-col class="mt-4 mb-6 weight-area" vs-type="flex">
            <span class="aisea-text-14-400-black" style="margin-right: 0.80rem;">WEIGHT</span>
            <vs-input
              class="input-weight mr-2 aisea-text-14-400-black"
              v-model="inputs.wasteOilWeight"
            ></vs-input>
            <span class="aisea-text-14-400-black">t</span>
          </vs-col>
          <vs-col class="mt-4 mb-6 k-g-area" vs-type="flex">
            <span class="mr-12 aisea-text-14-400-black">K.G</span>
            <vs-input 
              class="input-k-g mr-2 aisea-text-14-400-black" 
              v-model="inputs.wasteOilValue"
            ></vs-input>
            <span class="aisea-text-14-400-black">m</span>
          </vs-col>
        </vs-col>
        <vs-col class="lubricant-area" vs-lg="6" vs-sm="6" vs-xs="12">
          <vs-col class="aisea-text-14-400-black">潤滑油</vs-col>
          <vs-col class="mt-4 mb-6 weight-area" vs-type="flex">
            <span class="aisea-text-14-400-black" style="margin-right: 0.80rem;">WEIGHT</span>
            <vs-input
              class="input-weight mr-2 aisea-text-14-400-black"
              v-model="inputs.lubricatingOilWeight"
            ></vs-input>
            <span class="aisea-text-14-400-black">t</span>
          </vs-col>
          <vs-col class="mt-4 mb-6 k-g-area" vs-type="flex">
            <span class="mr-12 aisea-text-14-400-black">K.G</span>
            <vs-input 
              class="input-k-g mr-2 aisea-text-14-400-black" 
              v-model="inputs.lubricatingOilValue"
            ></vs-input>
            <span class="aisea-text-14-400-black">m</span>
          </vs-col>
        </vs-col>
        <vs-col class="mt-4 k-g-area" vs-type="flex">
          <vs-button class="canccel-button aisea-text-14-400-white" @click="cancel">
            キャンセル
          </vs-button>
          <vs-button class="update-button aisea-text-14-400-white" @click="update">
            保存
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("ecoShip");

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    vesselId: { type: String },
    editCondition: { type: Array }
  },
  data() {
    return {
      showDialog: false,
      title: "ロスト登録",
      inputs: {
        wasteOilValue: null,
        wasteOilWeight: null,
        lubricatingOilValue: null,
        lubricatingOilWeight: null
      }
    };
  },
  methods: {
    ...mapActions(["updateLostFireStore"]),
    update() {
      let wasteOilValue = this.inputs.wasteOilValue * 100;
      let wasteOilWeight = this.inputs.wasteOilWeight * 100;
      let lubricatingOilValue = this.inputs.lubricatingOilValue * 100;
      let lubricatingOilWeight = this.inputs.lubricatingOilWeight * 100;

      let payload = {
        enterprise_id: this.$store.state.auth.user.id,
        vessel_id: this.vesselId,
        wasteOilValue: wasteOilValue,
        wasteOilWeight: wasteOilWeight,
        lubricatingOilValue: lubricatingOilValue,
        lubricatingOilWeight: lubricatingOilWeight,
      };

      try {
        this.updateLostFireStore(payload);
        this.$vs.notify({
          title: "データを保存しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center",
        });
        this.showDialog = false;
      } catch(error) {
        if(error.code == "422") {
          let validationErrors = error.data.validation_results.map((element) => {
            let target = element.target.split(/\./);
            let label = this.inputs[target[1]].label;
            let message = element.message;
            return {
              label: label,
              message: message,
            };
          });
          this.$refs.errorDialog.open("エラー", null, validationErrors);
        } else {
          this.$refs.errorDialog.open("エラー", error.message, null);
        }
      }
    },
    show() {
      this.inputs.wasteOilValue = this.editCondition[0].vn;
      this.inputs.wasteOilWeight = this.editCondition[0].vs;
      this.inputs.lubricatingOilValue = this.editCondition[1].vn;
      this.inputs.lubricatingOilWeight = this.editCondition[1].vs;

      this.showDialog = true;
    },
    close() {
      this.showDialog = false;
    },
    cancel() {
      this.showDialog = false;
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

.update-button {
  background: $aisea-blue !important;
  margin-left: 3%;
}

.canccel-button {
  background: $aisea-slightly-gray !important;
}

.con-vs-dialog .vs-dialog footer {
  justify-content: flex-start;
}

#dialog-lost-edit {
  padding: 10px;
  display: flex;

  .weight-area,
  .k-g-area {
    justify-content: flex-start;
    align-items: center;
  }
  .input-weight,
  .input-k-g {
    width: 120px;
  }
}

footer {
  justify-content: flex-start;
}
</style>
